import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ClientService} from '../../../../services/client.service';

@Component({
  selector: 'app-client-revoke-dialog',
  templateUrl: './client-revoke-dialog.component.html',
})
export class ClientRevokeDialogComponent implements OnInit {

  clientId;
  isLoading = false;
  onRevoke = new EventEmitter<void>();

  constructor(public dialogRef: MatDialogRef<ClientRevokeDialogComponent>,
              private clientService: ClientService,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit(): void {
    this.clientId = this.data.clientId;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  revoke() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.clientService.revoke(this.clientId).subscribe(() => {
      this.onRevoke.emit();
      this.cancel();
      this.isLoading = false;
    });
  }
}
